export default __webpack_public_path__ + "static/media/icon.dbd94728.png";